export default function Pointers() {
  return (
    <div className="hidden w-full lg:w-3/4 mx-auto px-4 md:px-0 mt-7 pt-7 lg:mt-10 lg:pt-10 sm:flex justify-between font-mono">
      <div>
        <p className="text-red-200 text-sm mb-5 tracking-wider">
          scores per each level
        </p>
        <ul className="list-none text-cyan-100">
          <li className="flex justify-between tracking-wide text-sm border-b border-b-gray-500 pb-2 mb-2">
            <span>Easy</span>
            <span>1 point</span>
          </li>
          <li className="flex justify-between tracking-wide text-sm border-b border-b-gray-500 pb-2 mb-2">
            <span>Medium</span>
            <span>2 points</span>
          </li>
          <li className="flex justify-between tracking-wide text-sm border-b border-b-gray-500 pb-2 mb-2">
            <span>Hard</span>
            <span>5 points</span>
          </li>
        </ul>
      </div>
      <div>
        <p className="text-yellow-200 text-sm mb-5 tracking-wider">
          total seconds for each level
        </p>
        <ul className="list-none text-cyan-100">
          <li className="flex justify-between tracking-wide text-sm border-b border-b-gray-500 pb-2 mb-2">
            <span>Easy</span>
            <span>8 seconds</span>
          </li>
          <li className="flex justify-between tracking-wide text-sm border-b border-b-gray-500 pb-2 mb-2">
            <span>Medium</span>
            <span>4 seconds</span>
          </li>
          <li className="flex justify-between tracking-wide text-sm border-b border-b-gray-500 pb-2 mb-2">
            <span>Hard</span>
            <span>2 seconds</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
